import React from 'react';
import './app.css';
import DrumMachine from '../drum-machine';
import 'bootstrap/dist/css/bootstrap.css';

export default function App() {
  return (
    <div id={'app'}>
      <DrumMachine />
    </div>
  );
}
